export default "__VITE_ASSET__3cdd36fc__"